import {TotalPrice} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/basket/v1/total_price.types';
import {useTranslation} from '@aboutyou/i18n';
import {
  FONT_SIZES,
  FONT_WEIGHTS,
  tabletAndUpLinaria,
} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React from 'react';

export interface BasketPageTitleProps {
  showPrice?: boolean;
}

export const BasketPageTitleView: React.FC<
  {
    basketItemCount: number;
    totalPrice?: TotalPrice;
  } & BasketPageTitleProps
> = ({basketItemCount}) => {
  const {t} = useTranslation();
  const isBasketEmpty = basketItemCount === 0;

  if (isBasketEmpty) {
    return null;
  }

  return (
    <BasketTitle data-testid="basketTitleAndItems">
      {t('Your Basket')}
    </BasketTitle>
  );
};

const BasketTitle = styled.h2`
  font-weight: ${FONT_WEIGHTS.w700};
  font-size: ${FONT_SIZES.px20};

  ${tabletAndUpLinaria(`font-size: ${FONT_SIZES.px32}`)}
`;
